export enum PROFILE_ENDPOINTS {
  PREFIX = 'profiles',
  CURRENT = 'current',
  BY_ID = ':id',
  ADD_SKILLS = ':id/skills',

}

export const AVATAR_FILES_API_PATH = 'api/files/avatar'
export const FILES_API_PATH = 'api/files'

export const STRIPE_API_PATH = 'api/stripe'
export const CHAT_WEBHOOK_PATH = 'private/chat'


export interface StripeField {
  'redirect_uri': string
  'stripe_user[business_type]': string
  'stripe_user[business_name]': string
  'stripe_user[first_name]': string
  'stripe_user[last_name]': string
  'stripe_user[email]': string
  'stripe_user[country]': string
}

export interface JobCategoryApi {
  getJobCategories()
}

export interface StripeAuthorize {
  authorizeUrl: string
}

export interface StripeApi {
  authorize()

  dashboard(id: string)

  payout(id: string)
}

export interface ProfileApi {

  addSkillToProfile(s: Skill, profileId: string)

  removeSkillFromProfile(s: Skill, profileId: string)

  updateProfileSkill(s: Skill, profileId: string, xp: ExperienceLevel)

  updateProfileRating(rating: Profile['rating'], profileId: string)

  addJobToProfile(jobId: string, profileId: string)

  removeJobFromProfile(profileId: string)

  getProfileById(id: string)

  createProfile(profile: Profile)

  updateProfile(p: Profile)

  getAllProfiles()

  getPublicProfiles()

  updatePublicState(profileId: string, isPublishable: boolean)

}

export interface SkillApi {
  autocomplete(query: string)
}

export interface LabApi {
  createLogo(prompt: Prompt)

  getPromptStyles()

  findUserPrompts(userId: string)
}

export interface NoteApi {
  addNote(note: INote)

  removeNote(noteId: string)

  updateNote(noteId: string, content: string)

  findNoteForSubject(subject: AnnotatedSubject, subjectId: string)

}

export interface PersonApi {
  current()

  getPersonById(id: string)

  createOfflinePerson(firstName: string, lastName: string, email: string)

  updateAvatar(id: string, avatar: string)

  updatePerson(p: Person)
}

export enum PersonType {
  MORAL = 'MORAL',
  PHYSICAL = 'PHYSICAL'
}

export enum Scope {
  EMPLOYEE = 'EMPLOYEE',
  CUSTOMER = 'CUSTOMER',
  PARTNER = 'PARTNER',
}

export enum Role {
  ADMIN = 'ADMIN',
  USER = 'USER',
}

export enum PaymentMode {
  SEPA = 'SEPA',
  NONE = 'NONE'
}

export interface Skill extends BaseEntity {
  key: string
  label: string
  usageCount: number
}


export interface ProfileSkill extends BaseEntity {
  skill: Skill
  experienceLevel?: ExperienceLevel
  profile: Profile | undefined
}

export enum SkillCategory {
  MAIN = 'main',
  SECONDARY = 'secondary',
  HARD = 'hard',
  SOFT = 'soft'
}

export enum Language {
  EN = 'EN',
  FR = 'FR'
}

export interface LangLabel {
  lang: Language,
  key: string,
  label: string

}

export enum JobCategoryTypes {
  TECH = 'TECH',
  DATA = 'DATA',
  VIDEO_GAMES = 'VIDEO_GAMES',
  PROJECT_MANAGER_AGILE = 'PROJECT_MANAGER_AGILE',
  WEB_GRAPHIC_DESIGN = 'WEB_GRAPHIC_DESIGN',
  PICTURE_SOUND = 'PICTURE_SOUND',
  MARKETING = 'MARKETING',
  COMMUNICATION = 'COMMUNICATION',
  BUSINESS_CONSULTING = 'BUSINESS_CONSULTING',
  OTHER = 'OTHER'
}

export interface BaseEntity {
  id: string | undefined
  version?: number
  removed: boolean
  dataScope?: DataScope
  __typename?: string
}

export interface Job extends BaseEntity {

  label: string | undefined
  category?: JobCategory
  baseSkills: Skill[]

}

export interface JobCategory extends BaseEntity {
  label: string
  category: JobCategoryTypes
  description: string
  jobs: Job[]
}


export interface Company extends BaseEntity {
  name: string
  email: string
}

export interface Workspace extends BaseEntity {

}

export interface Address extends BaseEntity {
  city: string
  country: string
  street: string
  postCode: string
  lat: number,
  lng: number
}

export enum ExperienceLevel {
  NONE = 'NONE',
  ENTRY = 'ENTRY',
  INTERMEDIATE = 'INTERMEDIATE',
  EXPERT = 'EXPERT',
}

export interface MoralPerson extends Person {

}

export interface Physical extends Person {

}

export enum DataScope {

  PARTIAL = 'PARTIAL',
  FULL = 'FULL'
}

export interface StripePaymentDashboard extends BaseEntity {
  loginLink: string
  balance: number
  pending: number
  stripeAccountId: string
}

export enum AnnotatedSubject {
  PersonModel = 'PersonModel'
}

export enum LogoType {
  IMG = 'IMG',
  SVG = 'SVG'
}

export interface StableDiffusionCheckpoint extends BaseEntity {
  label: string
  model: string
}

export interface StableDiffusionModel extends StableDiffusionCheckpoint {

}

export interface StableDiffusionRefiner extends StableDiffusionCheckpoint {

}

export interface StableDiffusionLora extends StableDiffusionCheckpoint {

}

export interface StableDiffusionControlNet extends StableDiffusionCheckpoint {
  weight: number
  type: ControlNetType
}

export enum ControlNetType {
  CANNY = "CANNY"
}

export interface PromptTemplate extends BaseEntity {
  promptTemplate?: string
  label: string
  negativePrompt?: string
  steps: number
  logo: string
  weight?:number
  lora?: string
  model: string
  refiner?: string
  controlNet?: string
}

export enum PromptType {

  IMG2IMG = 'IMG2IMG',
  TXT2IMG = 'TXT2IMG'
}

export enum PromptStyle {
  PICTORAL = 'PICTORAL',
  MASCOT = 'MASCOT',
  ABSTRACT = 'ABSTRACT',
  LOGOTYPE = 'LOGOTYPE',
  MONOGRAM = 'MONOGRAM',
  LINEAR = 'LINEAR',
  ORIGAMI = 'ORIGAMI',
  FREE = 'FREE'


}

export interface Prompt {
  prompt: string
  modelId?: string
  weight?: number
  inputImage?: string | null
  userId: string
  type: PromptType
  promptTemplateId: string
}

export interface StableDiffusionServer extends BaseEntity{
  url:string
  lastUse:Date
  pendingTasks:number
  isAlive:boolean
}

export interface PromptResult {
  id: string
  prompt: string
  userId: string
  inputWeight: number
  creationDate: Date
  model: string
  promptTemplateLabel: string
  file: File
  inputImage: File
}

export interface INote extends BaseEntity {
  subject: AnnotatedSubject
  subjectId: string
  owner?: Person
  content: string
  createdAt?: Date
  updatedAt?: Date
}

export interface Profile extends BaseEntity {
  job: Job
  person: Person
  publicConsent: boolean
  internalConsent: boolean
  experienceLevel: ExperienceLevel
  rating: 0 | 1 | 2 | 3 | 4 | 5
  canRead?: boolean
  skills: ProfileSkill[]
  mainsSkills: ProfileSkill[]
  portfolio: string
  completion: number
  description: string | undefined
  available: boolean
  price: number
  completionNotified?: boolean
}

export interface Product extends BaseEntity {
  name: string,
  slug: string,
  minPrice: string,
  maxPrice: string
}

export interface Project extends BaseEntity {
  // select: Task[]

  state: ProjectState
  selectedProducts: Product[]
  name: string
  internalRoom: string,
  publicRoom: string,
  internalRoomId: string,
  publicRoomId: string,
  internalRoomInviteUrl: string,
  publicRoomInviteUrl: string,
  description: string
  owners: Person[] //TODO
  dueDate?: Date
}

interface Step {
  parentStep: Step
}

interface Task {
  title: string
  description: string
  effort: number
  project: Project
  step: Step
  owners: Person[]
  candidates: Person[]
  assignee: Person
}

export interface DBFile extends File {
  file: Uint8Array
}

export interface FsFile extends File {
  path: string
}

export interface File extends BaseEntity {
  lastModifiedBy?: string;
  filename?: string
  mimetype?: string
  encoding?: string;
  size?: number;
}

export enum InvoiceState {
  DRAFT = 'DRAFT',
  CANCELED = 'CANCELED',
  SUBMITTED = 'SUBMITTED',
}

export enum PaymentState {
  NOT_PAID = 'NOT_PAID',
  PROCESSING = 'PROCESSING',
  CREATED = 'CREATED',
  PAID = 'PAID',
  PARTIAL = 'PARTIAL',
}

export enum ProjectState {
  QUALIFIED = 'QUALIFIED',
  PROPOSITION = 'PROPOSITION',
  STARTED = 'STARTED',
  CANCELED = 'CANCELED'
}


export interface SupplierInvoice extends Invoice {

}

export interface CustomerInvoice extends Invoice {
}

export enum QuoteState {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  DECLINED = 'DECLINED'
}

export interface SupplierQuote extends Quote {

}


export interface Quote extends BaseEntity {
  quoteDate: Date
  state: QuoteState
  submitter: Person
  amountUntaxed: number
  amount: number
  file: File | undefined
  reference: string
}

export interface Invoice extends BaseEntity {
  paymentState: PaymentState
  state: InvoiceState
  reference: string
  invoiceDate: Date
  amountUntaxed: number
  amountTotal: number
  file: File | undefined
  submitter: Person
  paymentLogs: PaymentLog[]
}


export interface PaymentLog extends BaseEntity {
  stripePaymentIntentId: string
  amount: number
  submitter: Person
  mode: PaymentMode
  invoice: Invoice
  state: PaymentState
}

export interface FileApi {
  deleteFile(id: string)

  uploadQuoteFile(file: any)

  uploadInvoiceFile(file: any)
}

export interface InvoiceApi {

  supplierInvoices(supplierId: string)

  deleteSupplierInvoice(id: string)

  paySupplierInvoice(id: string, paymentMode: PaymentMode)

  createSupplierInvoice(supplierInvoice: SupplierInvoice)

  findAllInvoices()
}

export interface QuoteApi {

  supplierQuotes(supplierId: string)

  deleteSupplierQuote(id: string)

  findAllQuotes()

  acceptSupplierQuote(id: string)

  declineSupplierQuote(id: string)

  createSupplierQuote(supplierQuote: SupplierQuote)
}

export interface ProjectApi {
  createProject(p: Project)

  updateProject(project: Project)

  getProjectById(id: string)

  deleteProject(id: string)

  projects()

  addProduct(projectId: string, product: Product)

  deleteProduct(projectId: string, productId: string)

}

export interface Person extends BaseEntity {
  state?: string
  stripeAccountId?: string
  hasAvatar?: boolean
  jobTitle: string
  email: string
  externalId: string | undefined
  firstName: string
  lastName: string
  phone: string
  scope: Scope
  role: Role
  personType: PersonType
  profile: Profile | undefined
  chatId: string
  chatUsername: string
}

export interface StyledBaseProps {
  className?: string,
  children?: any
}

export const isSuperUser = (user: Person) => {
  return user.role === Role.ADMIN && user.scope === Scope.EMPLOYEE
}

export const isEmployee = (user: Person) => {
  return user.role === Role.USER && user.scope === Scope.EMPLOYEE
}

export const isPartner = (user: Person) => {
  return user.role === Role.USER && user.scope === Scope.PARTNER
}

export const isCustomer = (user: Person) => {
  return user.role === Role.USER && user.scope === Scope.CUSTOMER
}

